import React from 'react';
import {Select} from "antd";
import {useSelector} from "react-redux";
import UseSetParams from "./UseSetParams";
import {getFilter} from "../../../store/TableRedux/TableRedux";

const FilterSelectOption = ({data}) => {
    const filter = useSelector((state) => state.TableRedux.filter);
    const [handleSetParams,] = UseSetParams(getFilter)
    const funcHandleSetParams = (newFilter) => {
        handleSetParams(newFilter)
    }

    const {filterName,loading,placeholder,options,className,mode='multiple'} = data
    return (
        <Select mode={mode} className={`w-100 ${className}`} allowClear
                value={filter[filterName] ? JSON.parse(filter[filterName]) : []}
                loading={loading} placeholder={placeholder}
                onChange={(e) => {
                    funcHandleSetParams([{
                        key: filterName, value: JSON.stringify(e)
                    }])

                }}
                filterOption={(input, option) => {
                    return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                }}
                options={options}
        />
    );
};

export default FilterSelectOption;